import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {  map, capitalize } from "lodash";
//import Lead from "./Lead";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { addClientAddListing, getClientAddListing, getHomePref } from "../../store/actions"
import backIcon from "../../assets/img/backIcon.png"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Tooltip
} from "reactstrap"
import CurrencyFormat from "react-currency-format";
const getCoordinates = async (address) => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=AIzaSyDr1UUVEHuq9Cu-Xs4-4hX-xqmM8qZ1_pw`,
    { credentials: 'include' }
  );
  const data = await response.json();
  if (data.status === "OK") {
    return data.results[0].geometry.location;
  }
  return null;
};

const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  //console.log("Distance: ", d);
  return d.toFixed(2);
};

class addListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      distanceMatrix: {},
    }
   
  }
  handleGoBack = (e) => {
    e.preventDefault();
    console.log("Go Back Triggered");
    const { history } = this.props;
    if (history.length !== "POP" ) {
      history.goBack();
    } else {
      history.push("/project"); 
    }
  };
  
   async componentDidMount() {
    const {  onGetHomePref } = this.props;
     if (this.props.location.state?.clientId) {
      onGetHomePref(this.props.location.state?.clientId);
    }
    const compareData = this.props.location.state?.compareData || [];
    const distanceMatrix = {};

    for (let listing of compareData) {
      const fullListingAddress = `${listing.listingAddress}, ${listing.city}`;
      const listingCoords = await getCoordinates(fullListingAddress);

      distanceMatrix[listing.mlsId] = {};

      for (let destination of listing.clientBuyerImportantDestinations) {
        const destinationCoords = await getCoordinates(destination.destinationAddress);
        if (listingCoords && destinationCoords) {
          const distance = calculateDistance(
            listingCoords.lat,
            listingCoords.lng,
            destinationCoords.lat,
            destinationCoords.lng
          );
          distanceMatrix[listing.mlsId][destination.destinationAddress] = distance;
        }
      }
    }

    this.setState({ distanceMatrix });
  }
  render() {
    const { loading, homeprefrences } = this.props;
    const compareData = this.props.location.state?.compareData || null;
    const allPreferences = new Set();
    compareData.forEach((listing) => {
      listing.clientAdditionalHomePreferences.forEach((pref) => {
        allPreferences.add(pref.clientAdditionalHomePreferenceAnswerTitle);
      });
    });
    const importDestinations = new Set();
    compareData.forEach((listing) => {
      listing.clientBuyerImportantDestinations.forEach((pref) => {
        importDestinations.add(pref.destinationTitle);
      });
    });
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Compare  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Buyer")}
              breadcrumbItem={this.props.t("Compare")}
            /> */}
            <Row>
              
              
              <Col xl="12">
              
			  <Row>
				<Col sm="12">
					 <Card className="mini-stats-wid"> 
                    <CardBody>
                      
                    <div className="row gy-2 gx-4  mb20">
                      <div className="col-sm-3 float-start">
                        <div className="col-sm-12">
                          <h4 className="compare-text"> <Link to="#" onClick={this.handleGoBack}><img src={backIcon} width='20px' /></Link> Compare Listings </h4>
                        </div>
                      </div>
                      <div className="col-sm-8 ">
                        {/* <div className="row float-end">
                          <div className="col-sm-auto">
                            
                            <Link to='/compare-not-match'><Button className="btn btn-primary w-md not-match">Not Match</Button></Link>
                          </div>

                          <div className="col-sm-auto">
                            <Link  to='/compare-match'><Button className="btn btn-primary w-md match">Match</Button></Link>
                          </div>
                        
                          <div className="col-sm-auto">
                            <Link  to='/compare-nice-to-have'><Button className="btn btn-primary w-md nice-to-have">Nice to have</Button></Link>
                          </div>
                          
                          
                        </div> */}
                      </div>
                    </div>
        <div className="clearfix"></div>
        
					  <div className="table-responsive">
					  	<table className="table mb-0 table">
                <thead>
                  <tr>
                  <th width="15%" className="txt-compare-head">Standard Preferences</th>
                  {compareData.map((listing) => (
                    <th key={listing.mlsId} className="text-center">
                      {listing.mlsurl ? (
                        <a href={listing.mlsurl} target="_blank" rel="noreferrer">{listing.mlsId}</a>
                      ) : (
                            <>
                              {listing.mlsId}
                            </>
                      )}
                      </th>
                  ))}
                  
                 
                  </tr>
                  <tr>
                  <th className="">Address</th>
                  {compareData.map((listing) => (
                    <td key={listing.listingType} className="text-center">{listing.listingAddress} { listing.listingCity ? " , " + listing.listingCity : '' } </td>
                  ))}
                 
                  </tr>
                  <tr>
                  <th className="">Type of house {homeprefrences?.typeOfHouse && ` - (${homeprefrences.typeOfHouse})`}</th>
                  {compareData.map((listing) => (
                    
                    <td key={listing.listingType} className="text-center">{listing?.clientStandardHomePreferences?.typeOfHouse || "-"}</td>
                  ))}
                 
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th >Price {homeprefrences?.minPrice && (
                        <>
                          {" - ("}
                          <CurrencyFormat
                            value={homeprefrences?.minPrice}
                            displayType="text"
                            thousandSeparator={true}
                            prefix={this.props.location.state?.currencyCode + " "}
                          />
                          {")"}
                        </>
                      )}</th>
                    {compareData.map((listing) => (
                    <td key={listing.listedPrice} className="text-center"><CurrencyFormat value={listing.listedPrice} displayType={'text'} thousandSeparator={true} prefix={this.props.location.state?.currencyCode + " "} /> </td>
                  ))}
                   
                  </tr>

                  <tr>
                    <th># Bedrooms  {homeprefrences?.bedRoom && ` - (${homeprefrences.bedRoom})`}</th>
                    {compareData.map((listing) => (
                    <td key={listing.listingBedroom} className="text-center">{listing.listingBedroom || "-"}</td>
                  ))}
                   
                  </tr>
                  <tr>
                    <th># of bathrooms {homeprefrences?.bathRoom && ` - (${homeprefrences.bathRoom})`}</th>
                    {compareData.map((listing) => (
                    <td key={listing.listingBathroom} className="text-center">{listing.listingBathroom || "-" }</td>
                  ))}
                  </tr>
                  <tr>
                    <th># of parking  {homeprefrences?.noParking && ` - (${homeprefrences.noParking})`}</th>
                    {compareData.map((listing) => (
                    <td key={listing.listingParking} className="text-center">{listing.listingParking || "-"}</td>
                  ))}
                  </tr>
                  <tr>
                    <th>Square feet {homeprefrences?.sqFeets && ` - (${homeprefrences.sqFeets})`}</th>
                    {compareData.map((listing) => (
                    
                    <td key={listing.listingType} className="text-center">{listing?.clientStandardHomePreferences?.sqFeets || "-"}</td>
                  ))}
                 
                  </tr>
                 
                  <tr>
                    <th className="txt-compare-head">Custom Preferences</th>
                    {compareData.map((listing, index) => (
                      <th key={listing.mlsId || index} className="text-center"></th>
                    ))}
                  </tr>

                  {[...allPreferences].map((preferenceTitle) => (
                      <tr key={preferenceTitle}>
                        <th>{preferenceTitle}</th>
                        {compareData.map((listing) => {
                          const preference = listing.clientAdditionalHomePreferences.find(
                            (p) => p.clientAdditionalHomePreferenceAnswerTitle === preferenceTitle
                          );
                          return (
                            <td key={listing.mlsId} className="text-center">
                              {preference ? preference.clientAdditionalHomePreferenceAnswerResponse || "N/A" : "N/A"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
            
             <tr>
                <th className="txt-compare-head">Important Destinations</th>
                {compareData.map((listing, index) => (
                  <th key={listing.mlsId || index} className="text-center"></th>
                ))}
              </tr>

              {/* {[...importDestinations].map((destiTitle) => (
                <tr key={destiTitle}>
                  <th>{destiTitle}</th>
                  {compareData.map((listing) => {
                    const hasDestination = listing.clientBuyerImportantDestinations.some(
                      (d) => d.destinationTitle === destiTitle
                    );
                    return (
                      <td key={listing.mlsId} className="text-center">
                      {hasDestination ? listing.listingAddress : "N/A"} 
                      
                      </td>
                    );
                  })}
                </tr>
              ))} */}
                        {[...importDestinations].map((destiTitle) => (
                          <tr key={destiTitle}>
                            <th>{destiTitle}</th>
                            {compareData.map((listing) => {
                              const destination = listing.clientBuyerImportantDestinations.find(
                                (d) => d.destinationTitle === destiTitle
                              );

                              const distance = destination
                                ? this.state.distanceMatrix?.[listing.mlsId]?.[destination.destinationAddress]
                                : null;

                              return (
                                <td key={listing.mlsId} className="text-center">
                                  {distance ? `${distance} km` : "Loading..."}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                       <tr>

                    <th className="txt-compare-head">What i liked</th>
                    {compareData.map((listing, index) => (
                      <td key={listing.listingType} className="text-center">{listing.clientStandardHomePreferences?.whatYouLike || '-'} </td>
                    ))}
                  </tr> 

                    <tr>

                    <th className="txt-compare-head">What i did not like</th>
                    {compareData.map((listing, index) => (
                      <td key={listing.listingType} className="text-center">{listing.clientStandardHomePreferences?.whatYouDislike || '-'} </td>
                    ))}
                  </tr> 
                                           
                </tbody>          
					  	</table>
						</div>
					</CardBody>
					</Card>
				</Col>
			</Row>
			
			
            </Col>
            
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
addListing.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  addClientAddListing:PropTypes.func,
  addListings:PropTypes.array,
  onGetClientAddListing:PropTypes.func,
  loading:PropTypes.object,
  location:PropTypes.object,
  onGetHomePref:PropTypes.func,
  homeprefrences:PropTypes.object

}
const mapStateToProps = ({ addListing, Prefrences }) => (
  {
    addListings:addListing.addListings,
    loading:addListing.loading,
    homeprefrences : Prefrences.homeprefrences,

  })
const mapDispatchToProps = dispatch => ({
  
  addClientAddListing: (data) => dispatch(addClientAddListing(data)),
  onGetClientAddListing:(clientId, agentId) => dispatch(getClientAddListing(clientId, agentId)),
  onGetHomePref: (clientId) => dispatch(getHomePref(clientId)),
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(addListing))
